import { AxiosError } from 'axios';
import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import {
  candidateSearchAdvancedQuery,
  IJobCandidateInteraction,
  ICandidate,
  getCandidateSearch,
  ICandidateRecentConversation,
  getCandidatesRecentSubmissions,
} from 'wisestep-api';

import { getCandidatePorfileMap } from '../../../features/candidates/talentpool/hooks/useTalentPoolSearch';
import { warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

interface ICRMCandidates {
  list: (ICandidate & { isSelected: boolean })[];
  pagesCount: number;
  stageStatus: ICandidateRecentConversation[];
  isError: boolean;
}

const useJobCrmListing = (
  query: IJobCandidateInteraction,
  setLoader: Dispatch<SetStateAction<boolean>>
): ICRMCandidates => {
  const [state, setState] = useState<ICRMCandidates>({
    list: [],
    pagesCount: 0,
    stageStatus: [],
    isError: false,
  });
  const setNotification = useNotificationStore((state) => state.setNotification);

  useEffect(() => {
    const fetchCandidates = async () => {
      try {
        if (query) {
          setLoader(true);
          const response =
            query.source == 'AI_Suggestions_new'
              ? await getCandidateSearch(query, true)
              : await candidateSearchAdvancedQuery(query);

          setLoader(false);
          const candidates = response.data;
          candidates.map((candidate) => {
            candidate.downloadSource = 'AI_MATCHING';
            candidate.source = candidate.sources?.[0] ?? '';
          });
          let enrichedCandidates = candidates;

          if (candidates.length > 0) {
            const profileImagesMap = await getCandidatePorfileMap(
              candidates.map((candidate) => candidate.id)
            );

            enrichedCandidates = candidates.map((candidate) => ({
              ...candidate,
              profileImage: profileImagesMap[candidate.id] ?? null,
            }));
          }
          if (enrichedCandidates) {
            setState((prev) => ({
              ...prev,
              pagesCount: Number(response.headers['x-total-count']),
              list: enrichedCandidates,
              isError: false,
            }));
          }
          const candidatesEntities = candidates.map((item) => ({
            email: item.email,
            profileUrls: item.profileURLs,
          }));
          const interactions = await getCandidatesRecentSubmissions(candidatesEntities).catch(
            (e) => {
              console.log(e);
            }
          );
          setState((prev) => ({
            ...prev,
            stageStatus: interactions?.data ?? [],
          }));
        }
      } catch (e) {
        const err = e as AxiosError;
        if (err.response?.status === 500) {
          setNotification(warning('Something Went Wrong , Please try again'));
        }
        setState((prev) => ({ ...prev, list: [], pagesCount: 0, isError: true }));
        setLoader(false);
      }
    };

    fetchCandidates();
  }, [query, setLoader, setNotification]);
  return state;
};

export default useJobCrmListing;
